import type { HeatmapRegion } from '../../../../types/heatmap';

export type ApiHeatmapRegion = {
  id: string;
  label?: string;
  coordinateX: number;
  coordinateY: number;
  width: number;
  height: number;
  color?: string;
};

export function buildHeatmapRegions(
  apiRegions: ApiHeatmapRegion[],
  imageWidth: number,
  imageHeight: number
): { regions: HeatmapRegion[]; referenceWidth: number; referenceHeight: number } {
  const referenceWidth =
    imageWidth > 0
      ? imageWidth
      : Math.max(...apiRegions.map(region => region.coordinateX + region.width), 1);

  const referenceHeight =
    imageHeight > 0
      ? imageHeight
      : Math.max(...apiRegions.map(region => region.coordinateY + region.height), 1);

  const regions: HeatmapRegion[] = apiRegions.map(region => ({
    id: region.id,
    label: region.label ?? region.id,
    x: region.coordinateX / referenceWidth,
    y: region.coordinateY / referenceHeight,
    width: region.width / referenceWidth,
    height: region.height / referenceHeight,
    ...(region.color ? { color: region.color } : {}),
  }));

  return { regions, referenceWidth, referenceHeight };
}
